import { create } from "zustand"

export const useAnalyticsStore = create((set, get) => ({
    prolongationFiles: [],
    setProlongationFiles: (prolongationFiles) => set({ prolongationFiles: prolongationFiles }),
}))
